<template>
  <div class="login-card__verification-email step-primary step-primary--1">
    <div>
      <!--            <div class="login-card__big-icon login-card__big-icon&#45;&#45;verification">-->
      <!--                <img src="../../../images/registration/email-verify.png" alt="Mailbox icon">-->
      <!--            </div>-->

      <div class="login-card__title-box">
        <h2 class="login-card__title">
          {{ trans.get('auth.card.verification.email.header') }}
        </h2>
        <!-- <p class="login-card__verification-desc">
            <span v-html='trans.get("auth.card.verification.email.message", { email: form.email })'></span>
        </p> -->

        <p
          class="login-card__verification-desc login-card__verification-desc--line-1"
          v-html='trans.get("auth.card.verification.email.message_line_1")'
        ></p>
        <p class="login-card__verification-desc login-card__verification-desc--email">{{ form.email }}</p>
        <p
          class="login-card__verification-desc login-card__verification-desc--line-2"
          v-html='trans.get("auth.card.verification.email.message_line_2")'
        >
          <!-- {{ trans.get("auth.card.verification.email.message_line_2") }} -->
        </p>


        <p class="login-card__verification-desc login-card__verification-desc--bottom">
          {{ trans.get('auth.card.verification.email.message_spam') }}
        </p>
      </div>

      <!--            <div v-for="domainLink in allDomainsLinks" class="login-card__buttons-box">-->
      <!--                <a href="#"-->
      <!--                   class="button button&#45;&#45;primary button__auth button__auth&#45;&#45;auto-w button-direct"-->
      <!--                   target="_blank">-->
      <!--                    {{ trans.get("auth.card.verification.email.mail_web_image") }}-->
      <!--                    &nbsp; <img class="login-card__email-logo" :src="domainLink.image" :alt="domainLink.name">-->
      <!--                </a>-->
      <!--            </div>-->

      <div v-if="mailWebObject" class="login-card__buttons-box">
        <a
          v-if="mailWebObject.image" :href="mailWebObject.url"
          class="button button--primary button__auth button__auth--auto-w button-direct" target="_blank"
        >
          {{ trans.get('auth.card.verification.email.mail_web_image', { url: mailWebObject.name }) }}
          &nbsp; <img class="login-card__email-logo" :src="mailWebObject.image" :alt="mailWebObject.name">
        </a>
        <a
          v-else :href="mailWebObject.url"
          class="button button--primary button__auth button__auth--auto-w button-direct" target="_blank"
        >
          {{ trans.get('auth.card.verification.email.mail_web', { url: mailWebObject.name }) }}
        </a>
      </div>
      <div v-if="changeEmail" class="card__info-box">
        <div>
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <div class="form-group">
                <validation-provider name="email" rules="required" v-slot="{ errors }" mode="eager">
                  <div class="change-email-input">
                    <label for="email">{{
                        trans.get('auth.card.verification.email.change_email_label')
                      }}</label>
                    <input
                      type="email" id="email" class="input-text__underline"
                      v-model="form.email" placeholder="E-mail"
                    >
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>

              <button type="submit" class="button__auth">
                {{ trans.get('auth.card.verification.email.change_email_form_button') }}
              </button>
            </form>
          </validation-observer>
        </div>
      </div>

      <div v-else class="card__info-box">
        <h2 class="card__title">
          {{ trans.get('auth.card.verification.email.info_header') }}
        </h2>

        <ul class="card__description">
          <li>
            {{ trans.get('auth.card.verification.email.info_1') }}
          </li>
          <li>
            {{ trans.get('auth.card.verification.email.info_2') }}

            <a @click.prevent="resendLink">
              {{ trans.get('auth.card.buttons.resend_link') }}
            </a>
            oder
            <a @click.prevent="changeEmail = true">
              {{ trans.get('auth.card.verification.email.change_email') }}
            </a>
          </li>
        </ul>
      </div>

      <Step :step="1"></Step>

      <button type="button" class="button button__link button--back" @click="goBack">
        <i class="demo-icon icon-left"> </i>
        <span>{{ trans.get('auth.card.buttons.back') }} </span>
      </button>
    </div>
  </div>
</template>
<script>

import AuthGoBackMixin from '../../../../js/front/components/Auth/AuthGoBackMixin';
import EmailDomainMixin from './EmailDomainMixin';
import Step from './Step';

export default {
  components: { Step },
  props: ['swapComponent', 'form'],
  mixins: [AuthGoBackMixin, EmailDomainMixin],
  data: () => ({
    linkResent: false,
    changeEmail: false
  }),
  methods: {
    onSubmit() {
      const self = this;
      axios.post(zRoute('register.email.update'), { email: this.form.email, })
        .then(function (response) {
          // if (response.data.status === 'success') {
          //     // if (window.globals.settings_verification_required) {
          //     self.swapComponent('auth-verification-email-card')
          // }

          self.$notify({
            group: 'custom-template',
            type: 'info',
            title: 'Info',
            text: self.trans.get('auth.card.verification.email.link_successfully_resent'),
            duration: 5000,
            data: {},
          });
        }, function (error) {
          if (error.response.status === 422) {
            if (!('email' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
    resendLink() {
      const self = this;
      axios.post(zRoute('verification.email.resend'))
        .then(function (response) {
            self.linkResent = true;

            self.$notify({
              group: 'custom-template',
              type: 'info',
              title: 'Info',
              text: self.trans.get('auth.card.verification.email.link_successfully_resent'),
              duration: 5000,
              data: {},
            });
          },
          function (error) {
            self.linkResent = false;
            if (error.response.status === 422) {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        );
    },
    goBack() {
      const self = this;
      axios.post(zRoute('logout')).then(function (response) {
        self.swapComponent('auth-welcome-card');
      });
    },
    async refreshCSRFToken() {
      axios.get(zRoute('ajax.csrf_token')).then((response) => {
        const token = response.data.csrfToken;
        document
          .querySelector('meta[name=csrf-token]')
          .setAttribute('content', token);
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      });
    },
  },
  activated() {
    this.linkResent = false;
    this.refreshCSRFToken();
  },
};
</script>
<style scoped lang="scss">
.login-card__verification-desc {

  &--email {
    font-weight: 900 !important;
    text-decoration: underline;
    white-space: nowrap;
    color: #575657
  }
}

.login-card__title {
  margin-bottom: 1rem;
}

.login-card__title-box {
  gap: .5rem !important;
}
</style>
